import React from "react";

import { formatDescStrategy, formatTitleStrategy } from '@utils';
import RouteLegend from "./RouteLegend";

interface CardSuggestionRouteProps {
  strategy: string
  saving?: string | null;
  onAccept: () => void;
  onRefuse: () => void;
  isLoading?: boolean;
  showCurrentRoute?: boolean;
  showSuggestedRoute?: boolean;
}

const CardSuggestionRoute: React.FC<CardSuggestionRouteProps> = ({
  saving,
  onAccept,
  onRefuse,
  strategy,
  isLoading = false,
  showCurrentRoute = true,
  showSuggestedRoute = true
}) => {
  return (
    <div className="display-flex flex-column bg-highlight-lightest border border-primary rounded padding-10 margin-bottom-20 gap-20">
      <div>
        <span className="text-bold text-size-16 text-color-dark">{formatTitleStrategy(strategy)}</span>
      </div>

      <div className='width-100pct'>
        <div className='width-100pct'>
          <span className="text-size-14 text-color-dark">{formatDescStrategy(strategy)}</span>
        </div>

        <div className='display-flex align-items-center width-100pct justify-content-between'>
          <div>
            <span className="display-flex text-size-14 text-color-dark text-bold align-items-center">
              {saving}
            </span>
          </div>

          <div className='display-flex align-items-center gap-5'>
            {isLoading ?
              <button
                className="btn btn-default"
                disabled={true}
              >
                Carregando...
              </button>
              :
              <>
                <button
                  className="btn btn-default"
                  onClick={onRefuse}
                  disabled={isLoading}
                >
                  {isLoading ? 'Carregando...' : 'Recusar'}
                </button>
                <button
                  className="btn btn-primary"
                  onClick={onAccept}
                  disabled={isLoading}
                >
                  {isLoading ? 'Carregando...' : 'Aceitar'}
                </button>
              </>
            }

          </div>
        </div>
        <RouteLegend
          showCurrentRoute={showCurrentRoute}
          showSuggestedRoute={showSuggestedRoute}
        />
      </div>
    </div>
  );
};

export default CardSuggestionRoute; 